import Spinner from "components/Spinner";

import PatientInformation from "../PatientInformation";
import SessionSummarize from "../SessionSummarize";
import VoiceRecorder from "../VoiceRecorder";

import { useSessionDashboard } from "./useSessionDashboard";

const steps = [
  { label: "Patient Info", component: PatientInformation },
  { label: "Recorder", component: VoiceRecorder },
  { label: "Session Summary", component: SessionSummarize },
];

export default function SessionDashboard() {
  const { step, isLoading, isFetching } = useSessionDashboard();

  const StepComponent = steps[step].component;

  if (isLoading || isFetching) {
    return (
      <div className="flex items-center justify-center min-h-screen">
        <Spinner />
      </div>
    );
  }

  return <StepComponent />;
}
